export default __webpack_public_path__ + "static/mx-a1b8bb76a4a5f9037267f7f2be3ea089.svg";